import { Link } from "react-router-dom";
import {
  Project1,
  Project2,
  Project3,
  Project5,
  Xora,
  Carepulse,
  Ecommerce,
  JobSprint,
  ShadcnDashboard,
  OmniConvert,
  VibeSync,
  StudyTracker,
  CoverCraftAI,
  AbiApp,
  DevLabs,
} from "../../Portfolio Asset/exportAsset";

export const projects = [
  {
    imgURL: DevLabs,
    title: "Dev Labs",
    subText:
      "DevLabs is an offline based self-paced, interactive platform with 15 hands-on courses featuring coding exercises and automatic progress tracking.",
    techStack: "Tech stack: React, Tailwind CSS, and Framer Motion",
    live: (
      <Link
        to="https://devlabs-beryl.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/DevLabs"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
  {
    imgURL: AbiApp,
    title: "Abi App",
    subText:
      "Abi App is a peer-to-peer delivery platform designed to make parcel delivery across Nigeria faster, more affordable, and more convenient.",
    techStack: "Tech stack: Html, Tailwind CSS, Javascript",
    live: (
      <Link
        to="https://abi-design-2.vercel.app/index.html"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/Abi_design_2"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: CoverCraftAI,
    title: "CoverCraft AI",
    subText:
      "CoverCraft AI is an AI-powered platform that helps users generate professional, personalized cover letters in seconds.",
    techStack: "Tech stack: React.js, TypeScript, Tailwind CSS, googleGenAI",
    live: (
      <Link
        to="https://cover-craft-ai-red.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/Cover-Craft-AI"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: StudyTracker,
    title: "Study Tracker",
    subText:
      "Study Tracker is a productivity-focused web application designed to help students and professionals plan, track, and optimize their learning sessions.",
    techStack:
      "Tech stack: React.js, TypeScript, Tailwind CSS, shadcn/ui, Local Storage, Supabase, Resend Api",
    live: (
      <Link
        to="https://study-tracker-sandy-zeta.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/StudyTracker"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: OmniConvert,
    title: "OmniConvert Ai",
    subText:
      "OmniConvert AI is a modern, high-performance file conversion web application that allows users to seamlessly convert images and documents directly in the browser.",
    techStack:
      "Tech stack: React.js, TypeScript, Tailwind CSS, shadcn/ui,express, Framer Motion, JSZip, File APIs",
    live: (
      <Link
        to="https://omni-convert-ai.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/OmniConvert-Ai"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: VibeSync,
    title: "Vibe Sync",
    subText:
      "VibeSync is a modern music and mood-based synchronization app designed to enhance listening experiences by matching sound, vibe, and emotional context in real time.",
    techStack:
      "Tech stack: React, TypeScript, Tailwind CSS, Firebase, shadcn UI",
    live: (
      <Link
        to="https://vibe-sync-ai-gamma.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/VibeSync-AI"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: ShadcnDashboard,
    title: "Shadcn Dashboard",
    subText:
      "Shadcn Dashboard is a modern admin dashboard built for managing users, analytics, and application data smooth user experience.",
    techStack:
      "Tech stack: Next.js, TypeScript, Tailwind CSS, shadcn/ui, React Hook Form, Zod",
    live: (
      <Link
        to="https://shadcn-dashboard-gamma.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/shadcn-dashboard"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: JobSprint,
    title: "JobSprint App",
    subText:
      "Job Sprint is a fast and easy-to-use platform to find and post jobs. Connect with top talent or discover your next opportunity seamlessly.",
    techStack:
      "Tech stack: NextJS, Typescript, Tailwind CSS, Postgresql, prisma, neonDB",
    live: (
      <Link
        to="https://job-sprint-8pqd.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/job-sprint"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: Ecommerce,
    title: "Ecommerce App",
    subText:
      "It is a stylish and user-friendly online store designed for a seamless shopping experience. Discover quality products, all in one sleek digital marketplace.",
    techStack: "Tech stack: NextJS, Typescript, Tailwind CSS, Stripe",
    live: (
      <Link
        to="https://ecommerce-app-murex-eight.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/ecommerce-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: Carepulse,
    title: "Carepulse App",
    subText:
      "Carepulse is a platform designed to securely store patient records, streamline appointments, and send automated SMS reminders to boost efficiency.",
    techStack:
      "Tech stack: NextJS, Typescript, Tailwind CSS, Sentry, AppWrite, Shadcn, Twilio",
    live: (
      <Link
        to="https://carepulse-flax-seven.vercel.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/Carepulse"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },

  {
    imgURL: Xora,
    title: "Xora Sass App",
    subText:
      "Xora is a Modern UI/UX SaaS website developed using React.js and Tailwind CSS that exemplifies modern UI/UX principles. It serves as a future of modern applications.",
    techStack: "Tech stack: React JS, Tailwind CSS, Netlify",
    live: (
      <Link
        to="https://sass-xora-app.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/Xora"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
  {
    imgURL: Project5,
    title: "Light Code",
    subText:
      "Light Code is your digital companion for achieving financial clarity. Experience a sleek interface guiding you towards a brighter and more secure financial future.",
    techStack: "Tech stack: React JS, Tailwind CSS, Netlify",
    live: (
      <Link
        to="https://light-code.netlify.app"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/light-code"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
  {
    imgURL: Project3,
    title: "Techlift Community",
    subText:
      "TechLift Community specializes in grooming talents and connecting them with startups in the ever-evolving tech space.",
    techStack: "Tech stack: React JS, CSS, Netlify",
    live: (
      <Link
        to="https://techlift-community.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/TechLiftCommunity/TechLift-Team1-Frontend"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
  {
    imgURL: Project1,
    title: "GPT 3 OpenAI",
    subText:
      "This web app is single page, and it's cross-functional for mobile devices. The app talks about ChatGPT and its possibilities.",
    techStack: "Tech stack: React JS, CSS, Netlify",
    live: (
      <Link
        to="https://chatgpt3-ai.netlify.app/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/GPT3-Modern-UI"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
  {
    imgURL: Project2,
    title: "Gerícht App",
    subText:
      "Welcome to Gerícht App, a delightful restaurant web app designed to elevate your dining experiences to new heights.",
    techStack: "Tech stack: React JS, CSS",
    live: (
      <Link
        to="https://restaurant-app-bc3d0.firebaseapp.com/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Live Preview
      </Link>
    ),
    github: (
      <Link
        to="https://github.com/HephzibahDesigns/Restaurant-App/tree/master/resturant-app"
        target="_blank"
        rel="noopener noreferrer"
      >
        View Code
      </Link>
    ),
  },
];
